import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LocalizedNavLink = ({ to, children, className, replace, ...props }) => {
  const { i18n } = useTranslation();
  
  const safeTo = to || '/';
  const currentLang = i18n.language || 'en';
 
  if (typeof safeTo !== 'string') {
    return (
      <NavLink to={safeTo} className={className} replace={replace} {...props}>
        {children}
      </NavLink>
    );
  }
  
  const localizedTo = `/${currentLang}${safeTo.startsWith('/') ? safeTo : '/' + safeTo}`;

  const shouldReplace = replace !== undefined ? replace : false;
  
  return (
    <NavLink 
      to={localizedTo} 
      className={className}
      replace={shouldReplace}
      {...props}
    >
      {children}
    </NavLink>
  );
};

export default LocalizedNavLink;